export default "__VITE_ASSET__iUA67Bu0__"